import WarFramePage from "../components/WarFramePage";
export default function WarBombingTaskPage() { return <WarFramePage taskKey="bombing" nextTo="/vilaghaboru/alak" />; }
